var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.563,14.808c11.633,0,18.244,8.845,18.765,17.583c0.642,10.812-12.5,23.998-16.823,28.329 C64.13,71.142,57.484,76.839,52.63,80.995c-0.855,0.734-1.654,1.415-2.409,2.071c-0.771-0.661-1.583-1.349-2.458-2.089 c-4.86-4.129-11.52-9.782-21.924-20.137C21.502,56.538,8.308,43.428,8.908,32.577c0.488-8.779,7.115-17.664,18.836-17.664 c0.365,0,0.73,0.007,1.092,0.026c8.942,0.437,15.536,10.137,15.582,10.208l5.695,8.698l5.665-8.728 c0.062-0.098,6.606-9.805,15.54-10.278C71.739,14.816,72.157,14.808,72.563,14.808 M72.563,7.557c-0.523,0-1.062,0.014-1.598,0.043 C58.366,8.268,50.089,21.033,50.089,21.033S41.757,8.312,29.152,7.695c-0.472-0.021-0.942-0.031-1.408-0.031 C12.752,7.666,2.75,19.197,2.031,32.152C1.302,45.35,13.487,58.541,21.109,66.115c16.357,16.28,23.611,21.13,29.132,26.521 c5.498-5.411,12.736-10.322,29.023-26.674c7.59-7.616,19.719-20.851,18.939-34.027C97.438,19.03,87.461,7.557,72.563,7.557 L72.563,7.557z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.46119cf57596c5450013ac55f51e68f0.svg";
export { ForwardRef as ReactComponent };